import { useSelectedApPayee } from '@/components/ApPayee/useChangeApPayee';
import { useMemo } from 'react';
import type { InvoiceTransaction } from '../../type';

/**
 * Custom hook to check if there is withholding_income_tax setting
 * @returns Whether there is "payee's setting" and "detailData's" of withholding_income_tax
 */
export const useHasWithholdingIncomeTax = (
  detailData: InvoiceTransaction[]
): boolean => {
  const selectedPayee = useSelectedApPayee();
  return useMemo(
    () =>
      selectedPayee?.is_withholding_tax ||
      detailData.some((field) => {
        return field.hasWithholdingIncomeTax;
      }),
    [selectedPayee?.is_withholding_tax, detailData]
  );
};
